import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Spacer, VStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { orpc } from '@/lib/api/orpc';
import { cn } from '@/lib/cn';
import { defaultNS, useTranslation } from '@/lib/i18n';
import AppProfilePrimaryChart from './-components/AppProfilePrimaryChartSkeleton';
import RecommendedActions from './-components/RecommendedActions';
import MonthlyActiveUserCard from './-components/stat-cards/MonthlyActiveUserCard';
import MonthlyCostCard from './-components/stat-cards/MonthlyCostCard';
import RenewalDateCard from './-components/stat-cards/RenewalDateCard';
import SavingCostCard from './-components/stat-cards/SavingCostCard';
import UsersCard from './-components/stat-cards/UsersCard';
import { useSoftware } from './-query';
export const Route = createFileRoute('/_staff/software/$id/_$id/')({
  component: SoftwareOverview
});
function SoftwareOverview() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.profile.app'
  });
  const {
    id
  } = Route.useParams();
  const {
    data: software
  } = useSoftware(id);
  useDocumentTitle(t('pageTitle', {
    name: software.info.name,
    interpolation: {
      escapeValue: false
    }
  }));

  // TODO: Gridコンポーネントを使用する
  return <VStack className="px-12 py-5">
      <SoftwareOverviewCards id={id} />
      <Spacer size={20} />
      <div className="grid grid-cols-[1fr_360px] gap-7">
        <AppProfilePrimaryChart />
        <RecommendedActions />
      </div>
    </VStack>;
}
function SoftwareOverviewCards({
  id
}: {
  id: string;
}) {
  const {
    data: software
  } = useSoftware(id);
  if (software.appIntegrationId === null) {
    return <BaseOverviewCards />;
  }
  return <IntegrationOverviewCards softwareId={id} />;
}
function BaseOverviewCards() {
  return <div className={cn('grid gap-5', 'grid-cols-4')}>
      <UsersCard />
      <MonthlyActiveUserCard />
      <RenewalDateCard />
      <SavingCostCard />
    </div>;
}

// AppIntegration 持ち Software 用 overview cards。
// `contract.hasPricing` で MonthlyCostCard をトグル (FREE / UNPREDICTABLE プランは
// 利用料カードを非表示) し grid-cols 数を切り替える。
function IntegrationOverviewCards({
  softwareId
}: {
  softwareId: string;
}) {
  const {
    data: contractData
  } = useSuspenseQuery(orpc.software.overviewAppContract.queryOptions({
    input: {
      softwareId
    }
  }));
  const hasPricing = contractData.appContract.hasPricing;
  return <div className={cn('grid gap-5', hasPricing ? 'grid-cols-5' : 'grid-cols-4')}>
      {hasPricing && <MonthlyCostCard />}
      <UsersCard />
      <MonthlyActiveUserCard />
      <RenewalDateCard />
      <SavingCostCard />
    </div>;
}